/* V9 companion bar reads V5's selected offer; V5 owns variant and submission. */
(() => {
  function sync() {
    const root = document.querySelector('[data-bavi-achat-v2]');
    const sticky = document.querySelector('#sticky-buy');
    if (!root || !sticky) return;
    const form = root.querySelector('[data-v2-form]');
    const offer = root.querySelector('[data-v2-offer].is-selected');
    const cta = root.querySelector('[data-v2-main-cta]');
    const button = sticky.querySelector('button[type="submit"]');
    if (!button || !form || !cta) return;
    button.setAttribute('form', form.getAttribute('id'));
    button.disabled = cta.disabled || document.documentElement.dataset.baviCartBusy === 'true';
    const price = root.querySelector('[data-v2-cta-price]');
    const shownPrice = sticky.querySelector('[data-show-price]');
    const label = sticky.querySelector('[data-sticky-label]');
    if (price && shownPrice) shownPrice.textContent = price.textContent;
    if (offer && label) label.textContent = offer.querySelector('.bavi-product-achat-v2__offer-title')?.textContent.trim() || '';
  }
  function bind() {
    const root = document.querySelector('[data-bavi-achat-v2]');
    if (root && root.dataset.v9CompanionBound !== 'true') {
      root.dataset.v9CompanionBound = 'true';
      root.addEventListener('click', sync);
      root.addEventListener('keydown', () => requestAnimationFrame(sync));
    }
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('bavi:cart-state', sync);
})();
